import SemiCircleProgress from "../../modals/scripts/semicircleprogressbar/index.es";
import "./halfcircleprogressbar.scss"

interface IHalfCircleProgressBar {
    currentValue: number,
    maxValue: number,
    minValue: number
}

const HalfCircleProgressBar = ({currentValue, maxValue, minValue}: IHalfCircleProgressBar) => {
    return (
        <>
            <SemiCircleProgress currentValue={currentValue} minValue={minValue} maxValue={maxValue} showPercentValue/>
        </>
    );
}

export default HalfCircleProgressBar;